import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PermissionGuard from "../../components/auth/PermissionGuard";
import ProtectedRoute from "../../components/auth/ProtectedRoute";
import FullScreenProtectedLayout from "../../components/layout/FullScreenProtectedLayout";
import MobileProtectedLayout from "../../components/layout/MobileProtectedLayout";
import { useAuth } from "../../hooks/useAuth";
import AppShell from "../layout/AppShell";
import { appRouteRecords, findRouteByPath, hasRouteAccess, PERMISSION_MATCH, readStoredLastPath, ROUTE_LAYOUTS } from "../navigation";
import RouteTitleSync from "./RouteTitleSync";

const DEFAULT_PROTECTED_PATH = "/dashboard";

const SmartDefaultRoute = () => {
    const auth = useAuth();
    const storedLastPath = readStoredLastPath();
    const matchedRoute = storedLastPath ? findRouteByPath(storedLastPath) : null;
    const canRestoreLastPath = matchedRoute && matchedRoute.requiresAuth && matchedRoute.path !== "/" && hasRouteAccess(matchedRoute, auth);

    return <Navigate to={canRestoreLastPath ? storedLastPath : DEFAULT_PROTECTED_PATH} replace />;
};

function wrapRouteElement(route) {
    const routeElement = route.key === "root" ? <SmartDefaultRoute /> : route.element;

    if (!route.requiresAuth) {
        return routeElement;
    }

    if (route.layout === ROUTE_LAYOUTS.FULLSCREEN) {
        return <FullScreenProtectedLayout permission={route.routePermission}>{routeElement}</FullScreenProtectedLayout>;
    }

    if (route.layout === ROUTE_LAYOUTS.MOBILE) {
        return <MobileProtectedLayout permission={route.routePermission}>{routeElement}</MobileProtectedLayout>;
    }

    const shellElement = route.layout === ROUTE_LAYOUTS.SHELL ? <AppShell>{routeElement}</AppShell> : routeElement;

    if (!route.routePermission) {
        return <ProtectedRoute>{shellElement}</ProtectedRoute>;
    }

    return (
        <ProtectedRoute>
            <PermissionGuard
                permission={route.routePermission}
                requireAll={route.routePermissionMatch === PERMISSION_MATCH.ALL}
                fallback={<Navigate to="/" replace />}
            >
                {shellElement}
            </PermissionGuard>
        </ProtectedRoute>
    );
}

const AppRouter = () => {
    return (
        <>
            <RouteTitleSync />
            <Routes>
                {appRouteRecords
                    .filter((route) => route.element !== null || route.key === "root")
                    .map((route) => (
                        <Route key={route.key} path={route.path} element={wrapRouteElement(route)} />
                    ))}
                <Route path="*" element={<div>404 页面不存在</div>} />
            </Routes>
        </>
    );
};

export default AppRouter;
